import CardSection from "../../../../conponents/CardSection/CardSection";
import Input from "../../../../conponents/InputField/InputField.jsx";
import styles from "./PersonalInfoSection.module.css";
import DateInput from "../../../../conponents/DateInput/DateInput";
import SegmentedControl from "../../../../conponents/SegmentedControl/SegmentedControl.jsx";


const PersonalInfoSection = ({

    values,

    errors,

    touched,

    handleChange,

    handleBlur,

    setFieldValue,

}) => {

    return (

        <CardSection title="اطلاعات شخصی">

            <div className={styles.container}>

                <Input

                    id="fullName"

                    name="fullName"

                    label="نام و نام خانوادگی"

                    value={values.fullName}

                    error={touched.fullName && errors.fullName}

                    onChange={handleChange}

                    onBlur={handleBlur}

                />

                <SegmentedControl

                    label="جنسیت"

                    value={values.gender}

                    onChange={(value)=>

                        setFieldValue(

                            "gender",

                            value

                        )

                    }

                    options={[

                        {

                            label:"مرد",

                            value:true,

                        },

                        {

                            label:"زن",

                            value:false,

                        },

                    ]}

                />

                <div>

                    <DateInput

                        label="تاریخ تولد"

                        value={values.birthDate}

                        onChange={(date)=>{

                            setFieldValue("birthDate",date);

                        }}

                        error={errors.birthDate}

                        touched={touched.birthDate}

                    />
                    {/* <DatePicker

                        value={values.birthDate}

                        calendar={persian}

                        locale={persianFa}

                        calendarPosition="bottom-right"

                        inputClass={styles.dateInput}

                        onChange={(date)=>

                            setFieldValue(

                                "birthDate",

                                date

                            )

                        }

                    /> */}

                </div>

            </div>

        </CardSection>

    );

};

export default PersonalInfoSection;